<template>
  <span>
    <!--<b-form-input v-model="convertedValue" size="sm" />-->
    <VueAutonumeric
      v-model="convertedValue"
      class="form-control auto-numeric"
      :options="{
        allowDecimalPadding: false,
        digitGroupSeparator: '',
        decimalCharacter: ',',
        decimalPlaces: 10,
        decimalCharacterAlternative: '.',
        currencySymbol: '\u00a0€',
        currencySymbolPlacement: 's',
        roundingMethod: 'U',
        emptyInputBehavior: 'zero',
        symbolWhenUnfocused: '',
        selectOnFocus: 'false',
        currencySymbol: '',
        negativePositiveSignPlacement: 'p'
      }"
      @blur="onBlur"
    ></VueAutonumeric>
  </span>
</template>

<script>
import VueAutonumeric from "../../components/shared/VueAutonumeric";

export default {
  name: "FluidPropEditor",
  components: { VueAutonumeric },
  props: {
    value: {
      type: Number,
      default: 0
    },
    factor: {
      type: Number,
      default: 1
    },

    //======================================
    /*

    Marco Dc 12/11/2021

    ### CIPRIANI (ex. CIAT) - 2021.11.11 - #58936 - BLOCCANTE - Conversioni sbagliate nella sessione fluidi ###

    Ho aggiunto la prop perchè
    la conversione non gestiva
    l'offset, dando un risultato sbagliato

    */
    offset: {
      type: Number,
      default: 0
    },

    //======================================

    inputDecimalNum: {
      type: Number,
      default: 0
    },
    delta: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      userInput: null
    };
  },
  computed: {
    convertedValue: {
      get() {
        // double fromValue = (val - from.OffSet.Value) * from.Fat.Value;
        // double multiplier = 1 / to.Fat.Value;
        // return fromValue * multiplier + to.OffSet.Value;

        var num = this.value * this.factor + this.offset;

        /*if (this.factor != 1) {
          num = 32 + this.value * this.factor;
        }*/

        var pwr = Math.pow(10, 8); /* this.inputDecimalNum */
        var num2 = Math.round((num + Number.EPSILON) * pwr) / pwr;

        if (num2 > 1) {
          var strNum = "" + num2;
          var afterComma = false;
          var prevChr = "";

          var strRes = "";

          for (var i = 0; i < strNum.length; i++) {
            var chr = strNum.charAt(i);
            if (chr == prevChr && afterComma) {
              break;
            }
            if (chr == "," || chr == ".") {
              afterComma = true;
            }
            strRes = strRes + chr;
            prevChr = chr;
          }

          return parseFloat(strRes);
        } else {
          return num2;
        }
      },
      set(val) {
        if (!val) val = 0;
        this.userInput = val;
        //this.handleInput(val);
      }
    }
  },
  watch: {},
  methods: {
    onBlur: function(e) {
      this.$emit("input", (parseFloat(this.userInput) - this.offset) / this.factor);
    },
    handleInput(e) {
      this.$emit("input", (parseFloat(e) - this.offset) / this.factor);
      /*if (this.factor != 1) {
        this.$emit("input", parseFloat(e) / this.factor - 32);
      } else {
        this.$emit("input", parseFloat(e));
      }*/
    }
  }
};
</script>

<style lang="scss">
$input-height: 30px;
.form-control {
  //padding: 0px;
  border-radius: 5px;
  height: $input-height !important;

  &.auto-numeric {
    padding: 0 5px;
    text-align: center;
  }
}
</style>
